"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("./utils");
/**
 * Returns rendered labels wrapped in a div.
 * @param {React.ComponentProps} props component props
 * @returns {React.ReactElement} Rendered labels
 * @private
 */
function Labels(_ref) {
  let {
    labels,
    rtl,
    renderWidth,
    shouldRenderLabels
  } = _ref;
  const dir = rtl ? 'right' : 'left';
  const between = renderWidth / (labels.length - 1);
  const offset = _utils.SLIDER_BAR_HEIGHT / 2;
  if (!shouldRenderLabels) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ux-slider-labels"
  }, labels.map((label, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "ux-slider-label",
      style: {
        [dir]: Math.round(offset + index * between)
      }
    }, /*#__PURE__*/_react.default.createElement("label", null, label));
  }));
}
Labels.propTypes = {
  labels: _propTypes.default.array,
  rtl: _propTypes.default.bool,
  renderWidth: _propTypes.default.number,
  shouldRenderLabels: _propTypes.default.bool
};
var _default = exports.default = Labels;